const VIEW_AS_KEY = 'lt_view_as';
const AI_OVERRIDE_KEY = 'lt_ai_override';
const GRAPH_ENABLED_KEY = 'lt_graph_enabled';
const INFRASTRUCTURE_ENABLED_KEY = 'lt_infrastructure_enabled';
const SCAN_OVERRIDE_KEY = 'lt_scan_override';

/** Returns the local AI override, or null if no override is set (falls back to server setting). */
export function getAiOverride(): boolean | null {
  try {
    const v = localStorage.getItem(AI_OVERRIDE_KEY);
    if (v === 'true') return true;
    if (v === 'false') return false;
  } catch { /* localStorage unavailable */ }
  return null;
}

export function setAiOverride(enabled: boolean): void {
  try { localStorage.setItem(AI_OVERRIDE_KEY, String(enabled)); } catch {}
}

export function clearAiOverride(): void {
  try { localStorage.removeItem(AI_OVERRIDE_KEY); } catch {}
}

export type ViewAsRole = 'admin' | 'engineer' | 'operator';

export function getViewAs(): ViewAsRole | null {
  try {
    const v = localStorage.getItem(VIEW_AS_KEY);
    if (v === 'admin' || v === 'engineer' || v === 'operator') return v;
  } catch { /* localStorage unavailable */ }
  return null;
}

export function setViewAs(role: ViewAsRole): void {
  try { localStorage.setItem(VIEW_AS_KEY, role); } catch {}
  window.location.reload();
}

export function clearViewAs(): void {
  try { localStorage.removeItem(VIEW_AS_KEY); } catch {}
  window.location.reload();
}

/** Graph workflow section visibility — off by default, opt-in via easter egg. */
export function getGraphEnabled(): boolean {
  try { return localStorage.getItem(GRAPH_ENABLED_KEY) === 'true'; } catch { return false; }
}

export function setGraphEnabled(enabled: boolean): void {
  try {
    if (enabled) localStorage.setItem(GRAPH_ENABLED_KEY, 'true');
    else localStorage.removeItem(GRAPH_ENABLED_KEY);
  } catch {}
}

/** Infrastructure nav section (Routers, Messages, DB Maintenance) — off by default, opt-in via easter egg for builders. */
export function getInfrastructureEnabled(): boolean {
  try { return localStorage.getItem(INFRASTRUCTURE_ENABLED_KEY) === 'true'; } catch { return false; }
}

export function setInfrastructureEnabled(enabled: boolean): void {
  try {
    if (enabled) localStorage.setItem(INFRASTRUCTURE_ENABLED_KEY, 'true');
    else localStorage.removeItem(INFRASTRUCTURE_ENABLED_KEY);
  } catch {}
}

/** Local scan-input override, or null when no override is set (falls back to settings.features.scanCodes). */
export function getScanOverride(): boolean | null {
  try {
    const v = localStorage.getItem(SCAN_OVERRIDE_KEY);
    if (v === 'true') return true;
    if (v === 'false') return false;
  } catch { /* localStorage unavailable */ }
  return null;
}

export function setScanOverride(enabled: boolean): void {
  try { localStorage.setItem(SCAN_OVERRIDE_KEY, String(enabled)); } catch {}
}

export function clearScanOverride(): void {
  try { localStorage.removeItem(SCAN_OVERRIDE_KEY); } catch {}
}
